import { createSlice } from "@reduxjs/toolkit";
import {
  ordersEditTabs,
  ordersTabs,
} from "../../pages/Order/Orders/Json/OrdersJson";
import {
  OrdersDetailModalFieldsJSON,
  OrdersEditDetailModalFieldsJSON,
} from "../../pages/Order/Orders/Json/OrderDetailsFieldsJSON";
import {
  ORD_FROM_DATE,
  ORD_TO_DATE,
  PMT_FROM_DATE,
  PMT_TO_DATE,
} from "../../Utils/FilterDateKeys";
import dateFormat from "dateformat";
import { ManualPaymentModalFieldJSON } from "../../pages/Order/Orders/Json/ManualPaymentFieldJSON";

const enterpriseid = localStorage.getItem("enterpriseid");
const userid = localStorage.getItem("userId");

const initialState = {
  orderList: [],
  productAttributeData: [],
  ordersData: {},
  orderId: "",
  ProposalFieldsJSON: {},
  ProposalLayoutJSON: [],
  ProposalRulesJSON: [],
  isNewRenderer: false,
  proposalJson: "",
  manualPaymentJson: {},
  selectedOrders: {
    tab: ordersTabs,
    tabEdit: ordersEditTabs,
    activeTabs: "details",
    redirectUrl: "",
    policyData: {},
    detailsData: {},
    selectedProductData: [],
    selectedProductInfo: {},
    productDropdown: [],
    customerDropdown: [],
    insurerDropdown: [],
    detailsFieldJson: OrdersDetailModalFieldsJSON,
    editDetailsFieldJson: OrdersEditDetailModalFieldsJSON,
    productVariant: [],
    productVariantState: {},
    selectedTransactionData: [],
    transactionData: [],
    invoiceFile: {},
    certificateFile: {},
    isInvoiceFileChanged: false,
    isCertificateFileChanged: false,
    getAllOrderDocument: [],
    productVariantEdit: {},
    handleManualPaymentModal: false,
    handleEditManualPaymentModal: false,
    manualPaymentFieldJson: ManualPaymentModalFieldJSON,
    manualPaymentMode: [],
    manualPaymentDetails: {},
    selectedPolicyData: {},
  },
  rmName: "",
  rmData: [],
  doctorCategory: {},
  productData: [],
  customerData: [],
  insurerData: [],
  productVariantModalState: {},
  qualification: "",
  ProductFieldsJSON: {},
  ProductLayoutJSON: [],
  allTransactionData: [],
  sorting: {
    column: "created_date",
    order: "DESC",
  },
  filter: {
    filterApi: true,
    isFormChanged: false,
    form: {
      // enterpriseid: enterpriseid,
      // user_id: userid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
  transactionSorting: {
    column: "code",
    order: "DESC",
  },
  transactionFilter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // user_id: userid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [PMT_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [PMT_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
  policyStatus: "",
  selectedAttributes: {},
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrderList: (state, action) => {
      state.orderList = action.payload;
    },
    setProductAttributesData: (state, action) => {
      state.productAttributeData = action.payload;
    },
    changeActiveTabs: (state, action) => {
      state.selectedOrders.activeTabs = action.payload;
    },
    setRedirectUrl: (state, action) => {
      state.selectedOrders.redirectUrl = action.payload;
    },
    setPolicyData: (state, action) => {
      state.selectedOrders.policyData = action.payload;
    },
    setDetailsData: (state, action) => {
      state.selectedOrders.detailsData = action.payload;
    },
    setSelectedProductData: (state, action) => {
      state.selectedOrders.selectedProductData = action.payload;
    },
    setSelectedProductInfo: (state, action) => {
      state.selectedOrders.selectedProductInfo = action.payload;
    },
    setTransactionData: (state, action) => {
      state.selectedOrders.transactionData = action.payload;
    },
    setSelectedTransactionData: (state, action) => {
      state.selectedOrders.selectedTransactionData = action.payload;
    },
    setInvoiceField: (state, action) => {
      state.selectedOrders.invoiceFile = action.payload;
    },
    setIsInvoiceFileChanged: (state, action) => {
      state.selectedOrders.isInvoiceFileChanged = action.payload;
    },
    setIsCertificateFileChanged: (state, action) => {
      state.selectedOrders.isCertificateFileChanged = action.payload;
    },
    setCertificateField: (state, action) => {
      state.selectedOrders.certificateFile = action.payload;
    },

    setProductFieldsJSON: (state, action) => {
      state.ProductFieldsJSON = action.payload;
    },
    setProductLayoutJSON: (state, action) => {
      state.ProductLayoutJSON = action.payload;
    },
    setProductDropdown(state, action) {
      state.selectedOrders.productDropdown = action.payload;
    },
    setCustomerDropdown(state, action) {
      state.selectedOrders.customerDropdown = action.payload;
    },
    setInsurerDropdown(state, action) {
      state.selectedOrders.insurerDropdown = action.payload;
    },
    setDetailsFieldJson(state, action) {
      state.selectedOrders.detailsFieldJson = action.payload;
    },
    setEditDetailsFieldJson(state, action) {
      state.selectedOrders.editDetailsFieldJson = action.payload;
    },
    setProductData(state, action) {
      state.productData = action.payload;
    },
    setProductVariant(state, action) {
      state.selectedOrders.productVariant = action.payload;
    },
    setProductVariantEdit(state, action) {
      state.selectedOrders.productVariantEdit = action.payload;
    },
    // setProductVariantState(state, action) {
    //   state.selectedOrders.productVariantState = action.payload;
    // },
    setProductVariantState(state, action) {
      switch (action.payload.type) {
        case "checkbox":
          const updatedState = {
            ...state,
            productVariantState: {
              ...state.selectedOrders.productVariantState,
              [action.payload.name]: action.payload.binary
                ? action.payload.checked
                  ? 0
                  : 1
                : action.payload.checked,
            },
          };
          return updatedState;
        default:
          const key = action.payload.key;
          const value = action.payload.value;

          // if values is "" then remove key from state
          // if (value === "") {
          //   const { [key]: omit, ...newFormRendererState } =
          //     state.formRendererState;
          //   state.formRendererState = newFormRendererState;
          // } else {
          state.selectedOrders.productVariantState = {
            ...state.selectedOrders.productVariantState,
            [key]: value,
          };
        // };
      }
    },
    resetProductState: (state) => {
      state.selectedOrders.productVariantState = {};
    },
    setAllTransactionData(state, action) {
      state.allTransactionData = action.payload;
    },
    setCustomerData(state, action) {
      state.customerData = action.payload;
    },
    setInsurerData(state, action) {
      state.insurerData = action.payload;
    },
    setOrderFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    // setOrderFilterForm: (state, action) => {
    //   state.filter.form = action.payload;
    // },
    setOrderFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // enterpriseid: enterpriseid,
            // user_id: userid,
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[ORD_FROM_DATE];
          delete state.filter.form[ORD_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setOrderFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setOrderSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setTransactionFilterApi(state, action) {
      state.transactionFilter.filterApi = action.payload;
    },
    // setOrderFilterForm: (state, action) => {
    //   state.filter.form = action.payload;
    // },
    setTransactionFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.transactionFilter.form = {
            // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // enterpriseid: enterpriseid,
            // user_id: userid,
          };
          state.transactionFilter.isFormChanged = true;
          state.transactionFilter.formCopy = state.transactionFilter.form;
          break;
        case "disableApplySpam":
          state.transactionFilter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.transactionFilter.form[ORD_FROM_DATE];
          delete state.transactionFilter.form[ORD_TO_DATE];
          state.transactionFilter.isFormChanged = true;
          break;
        default:
          state.transactionFilter.form = {
            ...state.transactionFilter.form,
            [action.payload.name]: action.payload.value,
          };
          state.transactionFilter.isFormChanged = true;
      }
    },
    setTransactionFilterFormCopy(state, action) {
      state.transactionFilter.formCopy = action.payload;
    },
    setTransactionSorting(state, action) {
      state.transactionSorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setRmName(state, action) {
      state.rmName = action.payload;
    },
    setProductVariantModalState(state, action) {
      state.productVariantModalState = action.payload;
    },
    setQualification(state, action) {
      state.qualification = action.payload;
    },
    resetVariantModalState: (state) => {
      state.productVariantModalState = {};
    },
    setDoctorCategory(state, action) {
      state.doctorCategory = action.payload;
    },
    setCreateOrdersData(state, action) {
      state.ordersData = action.payload;
    },
    setOrderId(state, action) {
      state.orderId = action.payload;
    },
    setProposalFieldsJSON: (state, action) => {
      state.ProposalFieldsJSON = action.payload;
    },
    setProposalLayoutJSON: (state, action) => {
      state.ProposalLayoutJSON = action.payload;
    },
    setProposalJson: (state, action) => {
      state.proposalJson = action.payload;
    },
    setManualPaymentJson: (state, action) => {
      state.manualPaymentJson = action.payload;
    },
    setPolicyStatus: (state, action) => {
      state.policyStatus = action.payload;
    },
    setGetAllOrderDocuments: (state, action) => {
      state.selectedOrders.getAllOrderDocument = action.payload;
    },
    setSelectedAttributes: (state, action) => {
      state.selectedAttributes = action.payload;
    },
    setHandleManualPaymentModal: (state, action) => {
      state.selectedOrders.handleManualPaymentModal = action.payload;
    },
    setManualPaymentFieldJson: (state, action) => {
      state.selectedOrders.manualPaymentFieldJson = action.payload;
    },
    setManualPaymentModeDropdown: (state, action) => {
      state.selectedOrders.manualPaymentMode = action.payload;
    },
    setEditManualPaymentModalDropdown: (state, action) => {
      state.selectedOrders.handleEditManualPaymentModal = action.payload;
    },
    setManualPaymentDetails: (state, action) => {
      state.selectedOrders.manualPaymentDetails = action.payload;
    },
    setRmData: (state, action) => {
      state.rmData = action.payload;
    },
    setSelectedPolicydata: (state, action) => {
      state.selectedOrders.selectedPolicyData = action.payload;
    },
    setProposalRulesJSON: (state, action) => {
      state.ProposalRulesJSON = action.payload;
    },
    setIsNewRenderer: (state, action) => {
      state.isNewRenderer =
        action.payload == null ? false : action.payload == 1 ? true : false;
    },
  },
});

export const {
  setOrderList,
  setProductAttributesData,
  changeActiveTabs,
  setRedirectUrl,
  setPolicyData,
  setDetailsData,
  setSelectedProductData,
  setSelectedProductInfo,
  setTransactionData,
  setInvoiceField,
  setIsCertificateFileChanged,
  setIsInvoiceFileChanged,
  setCertificateField,
  setSelectedTransactionData,
  setProductFieldsJSON,
  setProductLayoutJSON,
  setProductDropdown,
  setCustomerDropdown,
  setInsurerDropdown,
  setDetailsFieldJson,
  setEditDetailsFieldJson,
  setProductData,
  setProductVariant,
  setProductVariantState,
  setAllTransactionData,
  resetProductState,
  setCustomerData,
  setInsurerData,
  setOrderFilterApi,
  setOrderFilterForm,
  setOrderFilterFormCopy,
  setOrderSorting,
  setTransactionFilterApi,
  setTransactionFilterForm,
  setTransactionFilterFormCopy,
  setTransactionSorting,
  setRmName,
  setProductVariantModalState,
  setQualification,
  resetVariantModalState,
  setDoctorCategory,
  setCreateOrdersData,
  setOrderId,
  setProposalFieldsJSON,
  setProposalLayoutJSON,
  setProposalJson,
  setManualPaymentJson,
  setPolicyStatus,
  setGetAllOrderDocuments,
  setProductVariantEdit,
  setSelectedAttributes,
  setHandleManualPaymentModal,
  setManualPaymentFieldJson,
  setManualPaymentModeDropdown,
  setEditManualPaymentModalDropdown,
  setManualPaymentDetails,
  setRmData,
  setSelectedPolicydata,
  setProposalRulesJSON,
  setIsNewRenderer,
} = orderSlice.actions;

export default orderSlice.reducer;
